module.exports = __webpack_public_path__ + "static/media/logo-dark-fr.433a86ae.svg";